import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const SectionHeader = styled.div`
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    display: grid;
    gap: ${theme.space[8]};
    grid-template-columns: minmax(0, 1fr) auto;
    min-height: ${theme.space[32]};
    padding: 0 ${theme.space[4]};
    width: 100%;
`;
